// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file types/v1/status.proto (package types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file types/v1/status.proto.
 */
export const file_types_v1_status: GenFile = /*@__PURE__*/
  fileDesc("ChV0eXBlcy92MS9zdGF0dXMucHJvdG8SCHR5cGVzLnYxKqcBCg5BcHByb3ZhbFN0YXR1cxIfChtBUFBST1ZBTF9TVEFUVVNfVU5TUEVDSUZJRUQQABIbChdBUFBST1ZBTF9TVEFUVVNfUEVORElORxABEhwKGEFQUFJPVkFMX1NUQVRVU19BUFBST1ZFRBACEhwKGEFQUFJPVkFMX1NUQVRVU19SRUpFQ1RFRBADEhsKF0FQUFJPVkFMX1NUQVRVU19TVEFNUEVEEAQq1AEKE0VDbGVhclBvc3RpbmdTdGF0dXMSJgoiRV9DTEVBUl9QT1NUSU5HX1NUQVRVU19VTlNQRUNJRklFRBAAEiUKIUVfQ0xFQVJfUE9TVElOR19TVEFUVVNfUFJPQ0VTU0lORxABEiQKIEVfQ0xFQVJfUE9TVElOR19TVEFUVVNfQ09NUExFVEVEEAISIwofRV9DTEVBUl9QT1NUSU5HX1NUQVRVU19SRUpFQ1RFRBADEiMKH0VfQ0xFQVJfUE9TVElOR19TVEFUVVNfQ0FOQ0VMRUQQBEKgAQoMY29tLnR5cGVzLnYxQgtTdGF0dXNQcm90b1ABWkJnaXRodWIuY29tL2VuZWNoYWluL2Vwb3NpdGlvbi1hcHAvYmFja2VuZC9nZW4vcHJvdG8vdHlwZXMvdjE7dHlwZXOiAgNUWFiqAghUeXBlcy5WMcoCCFR5cGVzXFYx4gIUVHlwZXNcVjFcR1BCTWV0YWRhdGHqAglUeXBlczo6VjFiBnByb3RvMw");

/**
 * @generated from enum types.v1.ApprovalStatus
 */
export enum ApprovalStatus {
  /**
   * @generated from enum value: APPROVAL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: APPROVAL_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: APPROVAL_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: APPROVAL_STATUS_REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * @generated from enum value: APPROVAL_STATUS_STAMPED = 4;
   */
  STAMPED = 4,
}

/**
 * Describes the enum types.v1.ApprovalStatus.
 */
export const ApprovalStatusSchema: GenEnum<ApprovalStatus> = /*@__PURE__*/
  enumDesc(file_types_v1_status, 0);

/**
 * @generated from enum types.v1.EClearPostingStatus
 */
export enum EClearPostingStatus {
  /**
   * @generated from enum value: E_CLEAR_POSTING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 処理中
   *
   * @generated from enum value: E_CLEAR_POSTING_STATUS_PROCESSING = 1;
   */
  PROCESSING = 1,

  /**
   * 完了
   *
   * @generated from enum value: E_CLEAR_POSTING_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * 却下
   *
   * @generated from enum value: E_CLEAR_POSTING_STATUS_REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * 取消済み
   *
   * @generated from enum value: E_CLEAR_POSTING_STATUS_CANCELED = 4;
   */
  CANCELED = 4,
}

/**
 * Describes the enum types.v1.EClearPostingStatus.
 */
export const EClearPostingStatusSchema: GenEnum<EClearPostingStatus> = /*@__PURE__*/
  enumDesc(file_types_v1_status, 1);

